export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[700px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            有任何关于555影视的建议、反馈或合作意向，欢迎随时联络
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-accent-100 mx-auto mb-5">
            <i className="ri-mail-send-line text-accent-700 text-2xl"></i>
          </div>
          <h3 className="text-lg font-heading text-foreground-900 mb-3">投稿与建议</h3>
          <p className="text-foreground-500 text-sm leading-relaxed mb-6 max-w-md mx-auto">
            如果您有影片推荐、功能建议或商务合作需求，请通过以下方式与我们取得联系。555影视重视每一位用户的声音，期待与您一起打造更好的免费在线看电影平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line text-foreground-500"></i>
              <span className="text-sm text-foreground-600">feedback@555mov.com</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer whitespace-nowrap">
              <i className="ri-wechat-line text-foreground-500"></i>
              <span className="text-sm text-foreground-600">关注公众号</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}